import Home from "./pages/home/Home.jsx";
import Register from "./pages/register/Register.jsx";
import Login from "./pages/login/Login.jsx";
import Profile from "./pages/profile/Profile.jsx";
import Trash from "./pages/trash/Trash.jsx"
import Saved from "./pages/saved/Saved.jsx"
import Archive from "./pages/archive/Archive.jsx"
import EditProfile from "./pages/editProfile/EditProfile.jsx"
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./context/AuthContext.js";
import { authorizationCall } from "./APICalls.js";
import { MessengerContextProvider } from './context/MessengerContext'

import { useJwt } from "react-jwt"
import Messenger from "./pages/messenger/Messenger.jsx";

function App() {

  //Initializing the states
  const [isFetching, setIsFetching] = useState(true)

  //Getting the context
  const {user, dispatch} = useContext(AuthContext)

  //Fetching the token from local storage and decoding it
  const token = String(localStorage.getItem('token'))
  const {decodedToken, isExpired} = useJwt(token)

  useEffect(() => {
    setIsFetching(true)
    if(decodedToken){
      const {_id} = decodedToken
      authorizationCall(_id, setIsFetching, isExpired, dispatch)
    }
    else{
      setIsFetching(false)
    }

  }, [decodedToken, isExpired])

  return (
    isFetching
    ||
    <Router>
      <Switch>
        <Route exact path="/">
          {user ? <Home /> : <Login />}
        </Route>
        <Route path="/login">
          {user ? <Redirect to="/"/> : <Login />}
        </Route>
        <Route path="/register">
        {user ? <Redirect to="/"/> : <Register />}
        </Route>
        <Route path="/profile/:username">
          {user ? <Profile /> : <Login />}
        </Route>
        <Route path="/saved">
          {user ? <Saved /> : <Login />}
        </Route>
        <Route path="/trash">
          {user ? <Trash /> : <Login />}
        </Route>
        <Route path="/archive">
          {user ? <Archive /> : <Login />}
        </Route>
        <Route path="/editProfile">
          {user ? <EditProfile /> : <Login />}
        </Route>
        <Route path="/roger">
          {user ? <MessengerContextProvider><Messenger /></MessengerContextProvider> : <Login />}
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
